import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from 'components/shared/Button';
import styles from './OrganizationSuspended.module.scss';
import { useSelector } from 'react-redux';
import { permissionsUserSelector } from 'features/user/userSlice';

const OrganizationSuspended: FC = () => {
  const navigate = useNavigate();

  const permissions = useSelector(permissionsUserSelector);
  const isBillingPageNavLinkAvailable = permissions?.some(
    (el) => el.name === 'ViewMySubscriptionPage'
  );

  return (
    <div className={styles.placeholder}>
      <p className={styles.title}>Organization is suspended</p>

      {isBillingPageNavLinkAvailable ? 
        <div className={styles.placeholderWrapper}>
          <p>{`You can't access this organization until the subscription is paid`}</p>
          <Button variant="primary" onClick={() => navigate('/subscription/plans')}>
            Choose plan
          </Button>
        </div> : 
        <p>{`You can't access this organization. Please contact the owner`}</p>
      }
    </div>
  )
};

export default OrganizationSuspended;
